import {
  InformationCard,
  InformationCardNoIcon,
} from "../../../../components/cards/infoCard";
import { DepositConfigurations } from "./deposits";
import { LoanConfiguration } from "./loans";
import { SharesConfiguration } from "./shares";

export const Configurations = () => {
  return (
    <div>
      <InformationCardNoIcon
        className="width-lim:max-w-[653px]"
        info={
          <p>
            Click the{" "}
            <span className="text-pry-green-200 font-medium">Edit</span> button
            to modify configurations
          </p>
        }
      />

      <div
        className="
        flex flex-row flex-wrap width-lim:flex-nowrap
        w-full gap-2 md:gap-6 mt-3
        "
      >
        <div className="w-full width-lim:max-w-[653px] order-last width-lim:order-first flex flex-col gap-2">
          <DepositConfigurations />

          <LoanConfiguration />

          <SharesConfiguration />
        </div>

        <InformationCard
          info={`Set up controls and configurations for loans, deposits, and shares.`}
          className="width-lim:!max-w-[345px] h-fit width-lim:sticky-top"
        />
      </div>
    </div>
  );
};
